import i18next from 'i18next'
import { Link } from 'react-router'
import { useToast } from './toast'
import { AsyncJob, jobFailureReasonEnum, jobStatusEnum } from 'src/services/async-jobs/models'
import { resolveTaskType } from 'src/services/async-jobs/task-type-registry'

export function useJobToast() {
  const { toast } = useToast()

  return {
    notifyJobTerminal(job: AsyncJob) {
      const { message, href, suppressToast } = resolveTaskType(job)
      if (suppressToast) return
      const isSuccess = job.status === jobStatusEnum.DONE
      const isFailed = job.status === jobStatusEnum.FAILED
      // A background job gated by the wallet fails cleanly with this reason
      // (there is no 402 outside a request) — surface it as an insufficient-
      // balance prompt with a top-up link, distinct from a generic failure.
      const isInsufficientBalance =
        isFailed && job.failureReason === jobFailureReasonEnum.INSUFFICIENT_BALANCE

      const type = isSuccess ? 'success' : isFailed ? 'error' : 'default'
      const title = isSuccess
        ? i18next.t('asyncJobs.taskCompleted')
        : isFailed
        ? i18next.t('asyncJobs.taskFailed')
        : i18next.t('asyncJobs.taskUpdate')

      if (isInsufficientBalance) {
        toast({
          title,
          type: 'error',
          description: (
            <span>
              {i18next.t('billing.insufficientBalance')}{' '}
              <Link to="/billing" className="font-medium underline">
                {i18next.t('billing.topUp')}
              </Link>
            </span>
          ),
        })
        return
      }

      const description = (
        <span>
          {isFailed && job.errorMessage ? job.errorMessage : message}
          {href && (
            <>
              {' '}
              <Link to={href} className="font-medium underline">
                {i18next.t('common.view')}
              </Link>
            </>
          )}
        </span>
      )

      toast({ title, description, type })
    },
  }
}
